import TagManager from 'react-gtm-module';

// eslint-disable-next-line import/prefer-default-export
export const gtmPayment = (price) => {
  const tagManagerArgs = {
    dataLayer: {
      event: 'pay',
      event_category: price,
      event_action: price,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
};
